// extracted by mini-css-extract-plugin
export default {"newsletterSignUp":"NewsletterSignUp_newsletterSignUp__U74y2"};